import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * SecciÃ³n de Notificaciones
 * - Preferencias de email, push, tipos de alertas
 * - Extensible para integraciÃ³n con servicios de notificaciÃ³n
 */
export default function NotificationsSection() {
    return (
        <Box>
            <Typography variant="h6">Preferencias de NotificaciÃ³n</Typography>
            {/* TODO: ConfiguraciÃ³n de notificaciones */}
            <Typography variant="body2" color="text.secondary">
                Configura cÃ³mo y quÃ© tipo de notificaciones deseas recibir.
            </Typography>
        </Box>
    );
} 